import React from 'react';
import './main-page.sass';

export const MainPage = ({children}) => {
  return (
   <div className='vv-main-page'>
     {children}
   </div>
  );
};
